export const themeOptionFactory = (theme) => ({
  assets: {
    bts: {
      mime: "image/png",
      url: "https://s3.venue.in.th/BTS_1b7a5f7174.jpg",
      width: 376,
      height: 377,
    },
    btsMap: {
      mime: "image/jpg",
      url: "https://s3.venue.in.th/bts_map_1dc9182de5.jpeg",
      width: 1190,
      height: 1612,
    },
    taxi: {
      mime: "image/jpg",
      url: "https://s3.venue.in.th/Taxi_b9709f996a.jpg",
      width: 376,
      height: 377,
    },
  },
  components: {
    EmTransportationPage: {
      styleOverrides: {
        root: {
          display: "flex",
          gap: theme.spacing(2, 2.5),
          alignItems: "flex-start",
          flexWrap: "wrap",
          "&>*": {
            flex: "0 0 min(calc(50% - 10px), 180px)", // Two cards shared width equally with horizontal gap of 20 px
            aspectRatio: "9 / 16", // 16:9 aspect ratio
          },
        },
      },
    },
    EmBusTransportationPage: {
      styleOverrides: {
        root: {},
        trafficTabs: {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
        trafficTab: {
          padding: theme.spacing(1.25, 1.5),
          fontSize: "0.875rem",
        },
        trafficTabPanel: {},
        trafficTabContainer: {
          paddingTop: theme.spacing(3),
          margin: theme.spacing(-4, -3), // Remove default padding from the main page content.
        },
        divider: {
          borderBottomWidth: "1px",
        },
        buttonWrapper: {
          marginTop: theme.spacing(2),
          gap: theme.spacing(2),
          display: "flex",
          overflowX: "auto",
          "::-webkit-scrollbar": {
            display: "none",
          },
        },
        button: {
          textTransform: "uppercase",
          fontSize: "0.75rem",
          borderRadius: "100px",
          fontWeight: 400,
          whiteSpace: "nowrap",
          minWidth: 170,
          "&:first-of-type": {
            marginLeft: theme.spacing(2),
          },
        },
        list: {
          padding: theme.spacing(0, 3),
        },
      },
    },
    EmTaxiTransportationPage: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          gap: theme.spacing(2.5),
        },
        image: {
          maxHeight: "376px",
          width: "100%",
          objectFit: "cover",
          aspectRatio: "1/1",
          borderRadius: "10px",
        },
        imageContainer: {
          display: "flex",
        },
        locationButtons: {
          display: "flex",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          gap: theme.spacing(2),
        },
        button: {
          textTransform: "uppercase",
          borderRadius: "9999px",
          padding: theme.spacing(2, 3),
        },
      },
    },
    EmBtsTransportationPage: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          gap: theme.spacing(2.5),
        },
        image: {
          height: "376px",
          width: "100%",
          objectFit: "cover",
          aspectRatio: "1/1",
          borderRadius: "10px",
        },
        imageContainer: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        },
        locationButtons: {
          display: "flex",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          gap: theme.spacing(2),
        },
        button: {
          textTransform: "uppercase",
          borderRadius: "9999px",
          padding: theme.spacing(2, 3),
        },
        mapButton: {
          textDecoration: "underline",
          padding: 0,
          paddingTop: theme.spacing(2),
        },
      },
    },
    TransportationCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "12px",
          "& .MuiCardContent-root": {
            transition: `all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`,
          },
          "&:active,&:hover": {
            "& .MuiCardContent-root": {
              backgroundColor: theme.palette.primary.dark,
            },
          },
        },
        cardMedia: {
          height: "75%",
        },
        cardIconWrapper: {
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
            color: theme.palette.common.white,
          },
        },
        cardContent: {
          height: "25%",
          gap: theme.spacing(1),
          padding: theme.spacing(1.4, 2.2),
          backgroundColor: theme.palette.secondary.dark,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          alignSelf: "stretch",
          "&:last-child": {
            paddingBottom: 0,
          },
        },
        cardTitle: {
          fontSize: "0.875rem",
          color: theme.palette.primary.contrastText,
          textAlign: "center",
          lineHeight: 1.57,
        },
      },
    },
    TransportationImageModal: {
      styleOverrides: {
        root: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: theme.spacing(2),
        },
        imageWrapper: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        },
        image: {
          borderRadius: "20px",
          width: "96%",
          [theme.breakpoints.up("sm")]: {
            width: "400px",
          },
        },
        closeButton: {
          padding: theme.spacing(0.5, 2),
          marginTop: theme.spacing(2),
          borderRadius: "9999px",
        },
      },
    },
    BusListItem: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1, 0, 0, 0),
        },
        listItemIcon: {
          color: theme.palette.primary.main,
        },
        titleText: {
          fontSize: "1rem",
          paddingBottom: theme.spacing(0.5),
        },
        originText: {
          fontSize: "0.875rem",
        },
        destinationText: {
          fontSize: "0.875rem",
        },
      },
    },
    TransportationTabPanel: {
      styleOverrides: {
        root: {
          overflowY: "auto",
          height: "calc(100dvh - 75px - 80px - 48px - 24px)",
        },
      },
    },
  },
})
